<template>
    <div>
        <div v-click-away="closeDropdown" :class="searchAutocompleteClass">
            <div v-if="upperLabel" class="form-input-text--label">
                <span class="form-input-text--label__text">{{ upperLabel }}:</span>
            </div>
            <input
                v-if="!selectedUser"
                v-model="searchTerm"
                type="text"
                class="search-autocomplete__input"
                :placeholder="placeholder"
                @keyup="inputChange"
                @focusin="focusIn()"
            />

            <div v-else>
                <div>
                    <label v-if="!upperLabel" class="form-field__label">
                        {{ $t('pages.company.company_clients.choosen_client') }}
                    </label>
                    <div :class="formFieldLook">
                        <common-user-avatar :user="selectedUser" :size="avatarSize"></common-user-avatar>
                        <div>
                            <p>{{ selectedUser.firstName }} {{ selectedUser.lastName }}</p>
                            <p>{{ selectedUser.mobile }}</p>
                        </div>
                        <common-icon name="trash" size="medium" @click="removeSelectedUser()"></common-icon>
                    </div>
                </div>
            </div>

            <div v-if="!!searchItems.length" class="search-autocomplete__suggestions">
                <div
                    v-for="(item, index) in searchItems"
                    :key="index"
                    class="search-autocomplete__suggestions--item"
                    @click="selectUser(item)"
                >
                    <common-user-avatar :user="item" :size="avatarSize"></common-user-avatar>
                    <div>
                        <p>{{ item.firstName }} {{ item.lastName }}</p>
                        <p>{{ item.mobile }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            upperLabel: { type: String, required: false, default: '' },
            avatarSize: { type: String, required: false, default: 'medium' },
            inputStyle: { type: String, required: false, default: '' },
            items: { type: Array, required: true },
            placeholder: { type: String, required: false, default: '' },
            selectedUser: { type: Object, required: false, default: undefined },
        },

        data() {
            return {
                searchTerm: '',
                searchItems: [],
            }
        },

        computed: {
            searchAutocompleteClass() {
                return {
                    'search-autocomplete__search-input': true,
                    'form-input-text': true,
                }
            },

            avatarSizeClass() {
                return {
                    [this.avatarSize]: true,
                }
            },

            formFieldLook() {
                return {
                    [`search-autocomplete__selected-user--${this.inputStyle}`]: true,
                    'search-autocomplete__selected-user': true,
                }
            },
        },

        methods: {
            inputChange() {
                this.searchItems = this.items.filter((item) => {
                    return `${item.firstName} ${item.lastName}`.toLowerCase().includes(this.searchTerm.toLowerCase())
                })
            },

            selectUser(item) {
                this.searchTerm = ''
                this.emitEvent({ name: 'user-selected', payload: item })
                this.searchItems = []
            },

            removeSelectedUser() {
                this.emitEvent({ name: 'user-removed' })
            },

            focusIn() {
                this.searchItems = this.items
            },

            closeDropdown() {
                this.searchItems = []
            },
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    @import 'styles/blocks/_search.scss';
</style>
